var canSendData = false
var requestInProgress = false
var playlist

const updateProgressBar = (player, timestamp) => {
  let progress = document.getElementById("progress");
  let progressBar = document.getElementById("progress-bar");
  if ( progress === null || progressBar === null ) return

  let duration = player.getDuration();
  if ( duration > 0 ) {
    let percentage = (timestamp / duration) * 100;
    progress.style.width = percentage + "%";
    progressBar.style.opacity = '1';

  } else {
    const onDurationChange = () => {
      duration = player.getDuration();
      if ( duration > 0 ) {
        let percentage = (timestamp / duration) * 100;
        progress.style.width = percentage + "%";
        progressBar.style.opacity = '1';

        player.off('metadata', onDurationChange);
        player.off('time', onDurationChange);
      }
    };

    player.on('metadata', onDurationChange);
    player.on('time', onDurationChange);

    // Extra precaution
    setTimeout(() => { onDurationChange() }, 500)
  }
};

const loadPlayerTime = (player) => {
  if ( TangibleJWConfig.video_time !== '' ) {
    const last_played_media_id = Object.keys(TangibleJWConfig.video_time)[0]
    const timestamp = parseFloat(TangibleJWConfig.video_time[last_played_media_id])

    for ( let i = 0; i < playlist.length; i++ ) {
      if ( playlist[i].mediaid === last_played_media_id ) {
        player.playlistItem(i)

        const onFirstFrameOrPlay = () => {
          player.off('firstFrame', onFirstFrameOrPlay);
          player.off('play', onFirstFrameOrPlay);
          player.seek(timestamp);
        };
        player.on('firstFrame', onFirstFrameOrPlay);
        player.on('play', onFirstFrameOrPlay);

        break
      }
    }

    updateProgressBar(player, timestamp);
  }
}

const savePlayerTime = (player) => {
  let currentTime = TangibleJWConfig.video_time === '' ? 0 : parseFloat(TangibleJWConfig.video_time)
  let completedVideo = null
  let playlistItems = playlist.map( item => item.mediaid )

  player.on( 'time', event => {
    currentTime = event.currentTime
    if ( !canSendData ) canSendData = true
  })

  player.on( 'complete', () => { completedVideo = player.getPlaylistItem().mediaid })

  setInterval(() => {
    if ( !canSendData || requestInProgress ) return

    let action = completedVideo ? 'save_jwp_completion' : 'save_jwp_progress'
    requestInProgress = true
    canSendData = false
    // Doing this in case there is more than one video in the playlist, and the current playlist item already changed
    let mediaID = completedVideo ?? player.getPlaylistItem().mediaid
    if ( completedVideo ) completedVideo = null

    // console.log('Sending data')
    jQuery.post(
      TangibleJWConfig.ajax_url,
      {
        action: action,
        currentTime: currentTime,
        postID: TangibleJWConfig.post_id,
        playlist: playlistItems,
        mediaID: mediaID,
      })
      .done( ( response ) => {
        // console.log('Success')
        requestInProgress = false
      })
      .fail( ( jqxhr, textStatus, error ) => {
        console.log(jqxhr, textStatus, error)
      });
  }, 2000)
}

jQuery('document').ready(() => {
  var playerContainer = document.querySelector(".jwplayer")
  if ( playerContainer === null || typeof jwplayer === "undefined" ) return
  var player = jwplayer(playerContainer.id)

  const setupPlayerEvents = ( playerInstance ) => {
    // Load and save player time only after ensuring we have the playlist
    const tryLoadingPlaylist = () => {
      const data = playerInstance.getPlaylist();
      if ( data && typeof data === 'object' ) {
        // We have the playlist, we can load and save player time
        playlist = data
        loadPlayerTime(playerInstance);
        savePlayerTime(playerInstance);
      } else {
        // No playlist yet, let's wait a bit and try again
        setTimeout(tryLoadingPlaylist, 200);
      }
    };
    // Initially try to load the playlist
    tryLoadingPlaylist();
  }

  setupPlayerEvents(player);
})


